import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import ModalNavigation from './ModalNavigation';
import useModalFocusManagement from '../hooks/useModalFocusManagement';
import updateUrl from '../actions/updateUrl';

const HistoryPageModal = ({setModalIsOpen, modalContent, currentModalItemIndex, setCurrentModalItemIndex, modalContentLength, language, setWindowLocationHash}) => {

	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-portrait-placeholder.png`;
	const {modalRef, closeButtonRef} = useModalFocusManagement({focusCloseButtonOn: [modalContent.id]});

	const handleCloseClick = () => {
		const relatedCardButton = document.querySelector(`.history-page-card__psuedo-button[aria-controls="modal-${modalContent.id}"]`);
		setModalIsOpen(false);
		if (setWindowLocationHash) setWindowLocationHash(null);
		if (relatedCardButton) {
			window.requestAnimationFrame(() => relatedCardButton.focus());
		}
	};
	useEffect(() => {
		updateUrl(modalContent.id);
	}, [modalContent.id]);
	
	return (
		<div ref={modalRef} className='modal' id={`modal-${modalContent.id}`} role='dialog' aria-modal='true' aria-labelledby={`modal-title-${modalContent.id}`}>
			<button ref={closeButtonRef} className='modal__close-btn' aria-label='close' onClick={handleCloseClick}></button>
			<div className='modal__main-content'>
				<div className='modal__image-container'>
					<div className='aspect-ratio-box'>
						<img src={modalContent.image ? modalContent.image : placeholderImgSrc} alt={modalContent.alt_text}/>
					</div>
				</div>
				<div className='modal__info'>
					<p className='modal__year'>{modalContent.label}</p>
					<h3 id={`modal-title-${modalContent.id}`} className='modal__title' dangerouslySetInnerHTML={{__html: modalContent.title}}></h3>
					<div className='modal__text' dangerouslySetInnerHTML={{__html: modalContent.content}}></div>
				</div>
			</div>
			<ModalNavigation 
				currentModalItemIndex={currentModalItemIndex}
				modalContentLength={modalContentLength}
				language={language}
				setCurrentModalItemIndex={setCurrentModalItemIndex}
			/>
		</div>
	)
}

export default HistoryPageModal;

HistoryPageModal.propTypes = {
	modalContent: PropTypes.object,
	setModalIsOpen: PropTypes.func,
	setCurrentModalItemIndex: PropTypes.func,
	modalContentLength: PropTypes.number,
	currentModalItemIndex: PropTypes.number,
	setModalContent: PropTypes.func,
	language: PropTypes.string,
	setWindowLocationHash: PropTypes.func,
}